<template>
  <page-option title="Báo cáo quản trị">
    <template #title>
      <v-avatar color="#E3FCF7" size="35">
        <v-icon color="#108F6E" size>mdi-view-dashboard</v-icon>
      </v-avatar>
      <div class="pl-2 title-page">Báo cáo quản trị </div>
    </template>
    <!-- Main -->
    <v-row class="ma-0">
      <v-col
        class="d-flex flex-column card-container"
        cols="12"
        lg="7"
        md="7"
        order-sm="1"
        sm="12"
        xl="6"
      >
        <div class="dashboard-header text-h6 flex-grow-0"> Dashboard </div>
        <FrequencyViewUserChart class="flex-grow-1" />
      </v-col>
      <v-col
        class="d-flex flex-column card-container"
        cols="12"
        lg="5"
        md="5"
        order-md="2"
        order-sm="3"
        sm="6"
        xl="3"
      >
        <div class="dashboard-header text-h6 flex-grow-0">Thiết bị</div>
        <DeviceChartArc class="flex-grow-1" />
      </v-col>
      <v-col
        class="d-flex flex-column card-container"
        cols="12"
        lg="5"
        md="5"
        order-md="3"
        order-sm="3"
        sm="6"
        xl="3"
      >
        <div class="dashboard-header text-h6 flex-grow-0">Trình duyệt</div>
        <BrowserChartArc class="flex-grow-1" />
      </v-col>
      <!-- <v-col
        cols="12"
        sm="12"
        md="7"
        lg="6"
        order-sm="2"
        order-md="4"
        class="d-flex flex-column card-container"
      >
        <div class="dashboard-header text-h6 flex-grow-0">
          Biểu đồ tần suất
        </div>
        <TrafficChannelChart class="flex-grow-1" />
      </v-col> -->
      <v-col
        class="d-flex flex-column card-container"
        cols="12"
        lg="7"
        md="7"
        order-md="4"
        order-sm="3"
        sm="12"
        xl="6"
      >
        <div class="dashboard-header text-h6 flex-grow-0">Người dùng</div>
        <FrequecyViewWeeklyChart class="flex-grow-1" />
      </v-col>
    </v-row>
  </page-option>
</template>

<script>
import DeviceChartArc from './chart/DeviceChartArc.vue'
import FrequecyViewWeeklyChart from './chart/FrequecyViewWeeklyChart.vue'
import BrowserChartArc from './chart/BrowserChartArc.vue'
import FrequencyViewUserChart from './chart/FrequencyViewUserChart.vue'
import TrafficChannelChart from './chart/TrafficChannelChart.vue'
export default {
  components: {
    DeviceChartArc,
    BrowserChartArc,
    FrequencyViewUserChart,
    // TrafficChannelChart,
    FrequecyViewWeeklyChart,
  },
  props: {},
  data: () => ({
    params: {},
  }),
  created() {},
  computed: {},
  methods: {},
}
</script>

<style scoped>
.dashboard-header {
  padding-bottom: 12px;
}
.v-tab {
  border-bottom: 3px solid transparent;
}
.tab-active {
  border-bottom: 3px solid var(--v-primary-base);
  font-weight: bold;
  color: black !important;
}
.card-container {
  height: 750px;
}
</style>
